(function () {
    'use strict';

    var module = angular.module('imApp');

    module.component('userUsergroup', {
        templateUrl: 'views/components/views/userUsergroup/userUsergroup.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'userUsergroupService', function ($stateParams, stateService, translateService, modalService, userUsergroupService) {
            var vm = this;

            let translations = {
                confirm_title: '',
                confirm_remove_rights_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                userName: $stateParams.get_username,
                bgUserGroup: {
                    selected: 'USERGROUPS',
                    buttons: [
                        { id: 'USERGROUPS', label: 'bg_userusergroup_usergroups', color: 'primary', onClick: () => vm.model.bgUserGroup.selected = 'USERGROUPS' },
                        { id: 'SUBSCRIPTIONS', label: 'bg_userusergroup_subscriptions', color: 'primary', onClick: () => vm.model.bgUserGroup.selected = 'SUBSCRIPTIONS' },
                        { id: 'WEBPAGES', label: 'bg_userusergroup_webpages', color: 'primary', onClick: () => vm.model.bgUserGroup.selected = 'WEBPAGES' }
                    ]
                },
                setting: {},
                items: [],
				gridSubscriptionsReady: false,
                gridWebPagesReady: false,
                lockedDisableUserGroups: false
            };

            vm.gridWebPages = {
				dataTask: {
					rememberId: 'w_p2subscriptions_edit_webpages_grid',
					loadSetupId: null,
					loadData: {},
					addRow: {
						method: null,
						parameters: null,
						autoSave: false,
						confirm: false
					},
					removeRow: {
						method: null,
						parameters: null,
						autoSave: false,
						confirm: false
					},
					saveData: {
						method: null,
						parameters: null,
						autoSave: false,
						confirm: false
					}
				},
				translations: [],
				config: {
					editColumns: [
						//{ key: 'test_column' }
						//'prod_name', 'stock_stockvalue', 'is_selected', { key: 'test_column', lookup: 1900, relations: [{ key: 'stockplace_name', value: 'item_id' }], optionfunc: true }, 'reg_date'
					],
					toolbar: {
						hidden: false,
						pdfExport: true,
						excelExport: true,
						filter: true,
						columnVisibility: true,
						headers: true,
						edit: false,
						lock: false,
						add: false,
						delete: false,
						save: false,
						wrapping: true,
						layouts: true,
						buttons: [
							//{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } },
							//{ name: 'test', text: '', func: function () { testItems(); } },
							//{ name: 'customSave', text: '', func: function () { saveItems(); }, icon: 'save' },
							//{ name: 'customAddBefore', text: '', func: function () { addItemBefore(); }, icon: 'insert-up' },
							//{ name: 'customAddAfter', text: '', func: function () { addItemAfter(); }, icon: 'insert-down' },
							//{ name: 'customDelete', text: '', func: function () { deleteItem(); }, icon: 'delete' }
						]
					},
					fixedHeader: true,
					keepSortOnAdd: false,
					keepSortOnCheckbox: false,
					keepSortOnIsSelected: false,
					rowClick: false,
					//navigation: {
					//	altNav: true,
					//	newLine: true
					//},
					specialFunc: {
                        newTab: true,
                        buttons: [
                            	//{ name: 'test', text: '', func: function (data) { testItems(data); }, icon: 'far-star' }
                        ]
                    },
					css: {
						altColor: true,
						textWrapping: false
					},
					onDataSourceChanges: function (e) {
						//console.log('onDataSourceChanges');
						//console.dir(e);
					},
					onDataChanged: function (changed, e) {
						//console.log('onDataChanged');
						//console.dir(e);
					}
				},
				kendo: {
					height: '100%',
					sortable: true,
					aggregate: true,
					pager: false,
					selectable: false, //'multiple, row'
					//persistSelection: false,
					filterable: false
				},
				optionfunc: null,
				gridfunc: null
			};
			
            vm.gridSubscriptions = {
				dataTask: {
					rememberId: 'w_userusergroup_subscriptions_grid',
					loadSetupId: null,
					loadData: {},
					addRow: {
						method: null,
						parameters: null,
						autoSave: false,
						confirm: false
					},
					removeRow: {
						method: null,
						parameters: null,
						autoSave: false,
						confirm: false
					},
					saveData: {
						method: null,
						parameters: null,
						autoSave: false,
						confirm: false
					}
				},
				translations: [],
				config: {
					editColumns: [
						//{ key: 'test_column' }
						//'prod_name', 'stock_stockvalue', 'is_selected', { key: 'test_column', lookup: 1900, relations: [{ key: 'stockplace_name', value: 'item_id' }], optionfunc: true }, 'reg_date'
					],
					toolbar: {
						hidden: false,
						pdfExport: true,
						excelExport: true,
						filter: true,
						columnVisibility: true,
						headers: true,
						edit: false,
						lock: false,
						add: false,
						delete: false,
						save: false,
						wrapping: true,
						layouts: true,
						buttons: [
							//{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } },
							//{ name: 'test', text: '', func: function () { testItems(); } },
							//{ name: 'customSave', text: '', func: function () { saveItems(); }, icon: 'save' },
							//{ name: 'customAddBefore', text: '', func: function () { addItemBefore(); }, icon: 'insert-up' },
							//{ name: 'customAddAfter', text: '', func: function () { addItemAfter(); }, icon: 'insert-down' },
							//{ name: 'customDelete', text: '', func: function () { deleteItem(); }, icon: 'delete' }
						]
					},
					fixedHeader: true,
					keepSortOnAdd: false,
					keepSortOnCheckbox: false,
					keepSortOnIsSelected: false,
					rowClick: false,
					//navigation: {
					//	altNav: true,
					//	newLine: true
					//},
					specialFunc: {
                        newTab: true,
                        buttons: [
                            	//{ name: 'test', text: '', func: function (data) { testItems(data); }, icon: 'far-star' }
                        ]
                    },
					css: {
						altColor: true,
						textWrapping: false
					},
					onDataSourceChanges: function (e) {
						//console.log('onDataSourceChanges');
						//console.dir(e);
					},
					onDataChanged: function (changed, e) {
						//console.log('onDataChanged');
						//console.dir(e);
					}
				},
				kendo: {
					height: '100%',
					sortable: true,
					aggregate: true,
					pager: false,
					selectable: false, //'multiple, row'
					//persistSelection: false,
					filterable: false
				},
				optionfunc: null,
				gridfunc: null
			};

            translateService.translateBatch(translations).then(function (data) {
                angular.forEach(translations, function (_, key) {
                    if (angular.isDefined(data[key])) {
                        translations[key] = data[key];
                    }
                });
            });

            userUsergroupService.getUserUserGroup({ portal_user_keyno: vm.model.userName }).then(function (result) {
                angular.copy(result[0], vm.model.setting);
				
                vm.gridSubscriptions.dataTask.loadData = {
					method: 2876,
					parameters: { portal_user_keyno: vm.model.userName }
				};

                vm.gridWebPages.dataTask.loadData = {
					method: 2875,
					parameters: { portal_user_keyno: vm.model.userName }
				};
				
				vm.model.gridSubscriptionsReady = true;
				vm.model.gridWebPagesReady = true;
            });

            userUsergroupService.loadUserUsergroupList(vm.model.userName).then(function (data) {
                angular.copy(data, vm.model.items);
            });
            
            vm.selectBgUserGroup = function (value) {
                vm.model.bgUserGroup.selected = value;
            };

            vm.disableUserUsergroup = function () {
                vm.model.lockedDisableUserGroups = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_remove_rights_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(function () {
                    userUsergroupService.loadUserUsergroupDisableUser(vm.model.userName).then(function () {
                        vm.model.lockedDisableUserGroups = false;

                        stateService.go('usersettings', { userid: vm.model.userName });
                    }, function () {
                        vm.model.lockedDisableUserGroups = false;
                    });
                }, function () {
                    vm.model.lockedDisableUserGroups = false;
                });
            };
        }]
    });
})();
